import type { JSX } from 'react';
import * as React from 'react';
import { DecoratorNode } from 'lexical';

type SerializedImageNode = {
  type: 'image';
  version: 1;
  src: string;
  altText: string;
};

export class ImageNode extends DecoratorNode<JSX.Element> {
  __src: string;
  __altText: string;

  static getType(): string {
    return 'image';
  }

  static clone(node: ImageNode): ImageNode {
    return new ImageNode(node.__src, node.__altText, node.__key);
  }

  constructor(src: string, altText: string = '', key?: string) {
    super(key);
    this.__src = src;
    this.__altText = altText;
  }

  createDOM(): HTMLElement {
    return document.createElement('span');
  }

  updateDOM(): false {
    return false;
  }

  decorate(): JSX.Element {
    return (
      <img
        src={this.__src}
        alt={this.__altText || '이미지'}
        style={{
          maxWidth: '350px',
          maxHeight: '350px',
          width: 'auto',
          height: 'auto',
          objectFit: 'contain',
        }}
      />
    );
  }

  setAltText(alt: string): void {
    const writable = this.getWritable();
    writable.__altText = alt;
  }

  getAltText(): string {
    return this.__altText;
  }

  static importJSON(serializedNode: SerializedImageNode): ImageNode {
    const { src, altText } = serializedNode;
    return new ImageNode(src, altText);
  }

  exportJSON(): SerializedImageNode {
    return {
      type: 'image',
      version: 1,
      src: this.__src,
      altText: this.__altText,
    };
  }
}

export function $isImageNode(node: unknown): node is ImageNode {
  return node instanceof ImageNode;
}
